import isPathnameRoot from './isPathnameRoot';

export default isPathnameRoot;
